import { createContext, useContext } from 'react';

import { HttpResource } from '../../../../core/libs/http-resource';
import { OrdersData } from '../../requests/get-ticket-operations.request';
import { OrdersDataStore } from './orders.store';

type OrdersCache = {
  ordersStore: OrdersDataStore;
  getOrdersRequest: HttpResource<void, OrdersData>;
};

const ordersContext = createContext<null | OrdersCache>(null);

export const useOrders = () => {
  const ordersStore = useContext(ordersContext);
  if (!ordersStore) {
    throw new Error('useOrdersStore must be used within OrdersCacheProvider');
  }
  return ordersStore;
};

export const OrdersCacheProvider = ordersContext.Provider;
